import axios from "axios";
import { PromiseHandler } from "../../handlers";
import { NotImplementedError, MadSDKAbortError } from "../../errors";
import { serviceInscapeStatusToInscapeStatus, InscapeFilterFields } from "../../models/creatives/inscape";
import { parseNewNewYorkApiResponse } from "../../utils";
/**
 * This is a unique handler because it doesn't follow the standard
 * Type -> Service Type like most handlers. The filter fields (orgId, creativeId)
 * don't exist in the InscapeStatus model, so we use a separate FilterType
 * generic to properly type the filter shape.
 */
class Inscape extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "inscape");
        this.toInscapeStatus = (status) => {
            return serviceInscapeStatusToInscapeStatus(status);
        };
    }
    /**
     * InscapeStatus uses `creativeID` as its unique identifier instead of `id`.
     * Override the default identifier key so the byId Map (in mad-hooks) is keyed correctly.
     */
    getIdentifierKey() {
        return "creativeID";
    }
    async findItems(filters) {
        const lookupId = filters?.where?.find((filter) => filter.field === InscapeFilterFields.CREATIVE_ID)?.value ||
            filters?.where?.find((filter) => filter.field === InscapeFilterFields.ORG_ID)?.value;
        if (!lookupId || typeof lookupId !== "string") {
            return [];
        }
        const url = `${this.sdk.urls.inscapeBaseUrl}/${lookupId}`;
        if (this.cache.has(url)) {
            const promise = this.cache.get(url);
            if (!promise) {
                return [];
            }
            return promise;
        }
        const req = axios
            .get(url, {
            headers: {
                Accept: "application/json"
            }
        })
            .then((res) => {
            const { data } = parseNewNewYorkApiResponse(res);
            return data.map((status) => this.toInscapeStatus(status));
        })
            .catch((error) => {
            if (axios.isCancel(error)) {
                throw new MadSDKAbortError();
            }
            else {
                throw error;
            }
        });
        this.cache.set(url, req);
        return req;
    }
    async saveItem() {
        throw new NotImplementedError("save");
    }
    async deleteItem() {
        throw new NotImplementedError("delete");
    }
}
export default Inscape;
//# sourceMappingURL=inscape.js.map